import { useEffect, useState } from "react";
import { ADMIN_WA, api, STORE_ADDRESS } from "@/lib/api";

const FALLBACK = { address: STORE_ADDRESS, admin_whatsapp: ADMIN_WA };
let cache = null;

export const formatWa = (wa) => "+" + String(wa).replace(/^62(\d{3})(\d{4})(\d+)$/, "62 $1-$2-$3");

export function useStoreInfo() {
  const [info, setInfo] = useState(cache || FALLBACK);
  useEffect(() => {
    if (cache) return;
    api.get("/store").then((r) => { cache = r.data; setInfo(r.data); }).catch(() => {});
  }, []);
  return info;
}
